/**
 * Marketing / tracking-attribution query params.
 *
 * These params are appended to otherwise-indexable landing URLs by ad
 * platforms and campaigns (e.g. /self-storage/texas/austin/?utm_source=google
 * &gclid=...). They describe *where the visitor came from*, not page state
 * (filters, pagination, sort), so they must NOT cause a page to be noindex.
 *
 * Deliberately maintained separately from ALLOWED_URL_PARAMS in
 * server/lib/optimizely/userAttributes.js. That list answers a different
 * question ("what should Optimizely see for targeting?") with a different
 * owner; a param added there for an experiment is not necessarily safe to
 * exclude from noindex here. Add a param to this list only when it is known
 * to never carry page state.
 */
export const TRACKING_PARAMS = new Set([
	// Traffic source
	"tsid",
	"traffic_source_id",

	// Google Ads
	"gclid",
	"gbraid",
	"wbraid",
	"gad_source",
	"gad_campaignid",

	// Meta/Facebook
	"fbclid",

	// Microsoft Ads
	"msclkid",

	// Ad platform metadata
	"pdv", // device
	"pgrid", // ad group ID
	"cpgnid", // campaign ID
	"ptaid", // target ID
	"mkwid" // keyword ID
]);

/**
 * True when a query-param key is a marketing/tracking param (any `utm_*`
 * variant or one of the known click/traffic identifiers) rather than page
 * state.
 *
 * @param {string} key - Query param name
 * @returns {boolean}
 */
export const isTrackingParam = (key) =>
	key.startsWith("utm_") || TRACKING_PARAMS.has(key);
